export default __webpack_public_path__ + "static/data-fund@2x-8c1b756532ad6ffa2e165c1d9b3a0082.png";